import React from "react";

const FurtherReadingByline = ({author, editor, translator}) => (
  <div>
    {(author) ? (
      <span className="further-reading__byline">
        By {author}
      </span>
    ) : null}
    {(editor) ? (
      <span className="further-reading__byline">
        Edited by {editor}
      </span>
    ) : null}
    {(translator) ? (
      <span className="further-reading__byline">
        Translated by {translator}
      </span>
    ) : null}
  </div>
);

export default FurtherReadingByline;